import { Link } from "react-router-dom";
import { PublicHeader } from "../components/PublicHeader";

export function NotFoundPage() {
  return (
    <div className="public-page">
      <PublicHeader />
      <main id="main-content" className="not-found-shell">
        <section className="not-found-card">
          <span className="eyebrow">PAGE NOT FOUND</span>
          <h1>Wrong door.</h1>
          <p>This page does not exist. Return to the public site or open your member dashboard.</p>
          <div className="hero-actions">
            <Link className="btn primary" to="/">BACK HOME</Link>
            <Link className="btn" to="/app">MEMBER APP</Link>
          </div>
        </section>
      </main>
    </div>
  );
}
